import { updateTransferArchive } from '@/api/apis';
import { setTransferCurrentNavigation } from '@/queue/ducks/slice';
import { Toastertype, TransferCurrentNavigation, keyType } from '@/queue/types';
import { OutlineToasterNotification } from '@/toaster/successNotification';
import {
  ACTION_FAILED_ERROR,
  ARCHIVED,
  ARCHIVE_TEXT,
  TRANSFER_ACTION_SUCCESSFULL,
  TRANSFER_QUEUE,
  UN_ARCHIVED,
  VIEW_THE_PAGE,
  transferMacrostatus
} from '@/utils/constants';
import { Box, Button, Link, Text, Tooltip } from '@chakra-ui/react';
import { AgGridReact } from 'ag-grid-react';
import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { useSearchParams } from 'react-router-dom';
import { toast } from 'react-toastify';

interface LooseObject {
  [key: string]: string;
}

/** Status color mapping for transfer states */
const statusColorMap: LooseObject = {
  outbound_transfer_confirmed: '#008000',
  outbound_transfer_complete: '#008000',
  queue_status_on_hold: '#ff0000',
};

export default function StatusCellRenderer(params: any) {
  const { value, valueFormatted, isStoreAdmin, isStoreAgent, reFetchData, data, } = params;
  const dispatch = useDispatch();
  const [searchParams, setURLSearchParams] = useSearchParams();
  const [isTransferArchiving, setIsTransferArchiving] = useState(false);
  const hasLinkedTransfer = !!data?.isSharedTransfer;
  const isArchived = !!data?.isArchive;

  // coditions to show linked option
  const hasShowTooltip =  hasLinkedTransfer;

   

  // const gridRef = params?.api?.gridOptionsWrapper?.gridOptions?.gridRef || null;
  // const ColumnDefs = gridRef?.current?.api.getColumnDefs() || []




  const navigateToArchive = () => {
    const urlParams = new URLSearchParams(window.location.search);
    const params: Record<string, string> = {};
    for (const [key, value] of urlParams.entries()) {
      params[key] = value;
    }
    setURLSearchParams({ ...params, archive: 'true' });
  };
  const navigateToTransferQueue = () => {
    searchParams.delete("archive");
    setURLSearchParams(searchParams);
    dispatch(setTransferCurrentNavigation(TransferCurrentNavigation.TRANSFER_QUEUE));
  };

  const onClickArchiveAction = async (isArchive: boolean) => {
    try {
      toast.dismiss();
      setIsTransferArchiving(true);
      await updateTransferArchive({ isArchive }, data?.id as string);
      setIsTransferArchiving(false);
      reFetchData();
      OutlineToasterNotification(
        Toastertype.success,
        TRANSFER_ACTION_SUCCESSFULL.replace(
          '{{ACTION}}',
          data?.isArchive ? UN_ARCHIVED : ARCHIVED
        ),
        data?.isArchive ? navigateToTransferQueue : navigateToArchive,
        VIEW_THE_PAGE.replace(
          '{{PAGE}}',
          data?.isArchive ? TRANSFER_QUEUE : ARCHIVE_TEXT.toLowerCase()
        )
      );
    } catch (err) {
      OutlineToasterNotification(
        Toastertype.error,
        ACTION_FAILED_ERROR,
        () => { },
        ``,
        true
      );
      setIsTransferArchiving(false);
    }
  };

  const renderLinkedBadge = () => (
    <Tooltip hasArrow placement="top" label="Linked Transfer from Sales Channel" color="black" bg="white">
      <Box
        as="span"
        className="transfer-status-wrapper__linked-badge"
        background="#6B46C1"
        color="white"
        fontSize="10px"
        fontWeight="bold"
        padding="2px 6px"
        borderRadius="4px"
        marginRight="8px"
      >
        LINKED
      </Box>
    </Tooltip>
  );

  const renderArchiveButton = () => (
    <Tooltip hasArrow placement="top" label={data?.isArchive ? 'Unarchive' : 'Archive'} color="black" bg="white">
      <Button
        className="transfer-status-wrapper__archive-btn"
        ref={(ref) => {
          if (!ref) return;
          ref.onclick = (e) => {
            e.stopPropagation();
            onClickArchiveAction(!data?.isArchive);
          };
        }}
        isLoading={isTransferArchiving}
      >
        <img src="/images/ui/archive-icon.svg" />
      </Button>
    </Tooltip>
  );

  if (!value) {
    return (
      <Box textTransform="uppercase" className="transfer-status-wrapper">
        <img src="https://www.ag-grid.com/example-assets/loading.gif" />
        &nbsp; Loading
      </Box>
    );
  }

  return (
    <Box textTransform={'uppercase'} className="transfer-status-wrapper">
      {/* && ColumnDefs.length && ColumnDefs[0].headerName === "Status" */}
      {((!value || value == undefined)) ? (
        <>
          <img src="https://www.ag-grid.com/example-assets/loading.gif" />
          &nbsp; Loading
        </>
      ) : (
        <>
          {(isStoreAdmin || isStoreAgent) && (
            <Tooltip
              hasArrow
              placement="top"
              label={data?.isArchive ? 'Unarchive' : 'Archive'}
              color={'black'}
              bg={'white'}
            >
              <Button
                className="transfer-status-wrapper__archive-btn"
                isDisabled={hasLinkedTransfer}
                sx={{
                    pointerEvents: hasLinkedTransfer ? 'none !important' : 'auto',
                    opacity: hasLinkedTransfer ? "0.6 !important" : "1",
                    cursor: hasLinkedTransfer ? 'not-allowed' : 'pointer',
                  }}
                onClick={(e) => {
                  e.stopPropagation();

                  if (hasLinkedTransfer) return;
                  onClickArchiveAction(!isArchived);
                }}
                isLoading={isTransferArchiving}
              >
                <img src="/images/ui/archive-icon.svg" />
              </Button>
            </Tooltip>
          )}
          <Box
            as={'span'}
            background={statusColorMap[value] || (value ? '#FFA500' : '')}
            className="transfer-status-wrapper__status-indicator"
          ></Box>
          {
            transferMacrostatus[
            (valueFormatted || value) as keyType<typeof transferMacrostatus>
            ]
          }   
          {hasShowTooltip && (
              <Tooltip
              hasArrow
              placement="top"
              label={`${data?.isArchive ? 'Linked transfer to GunBroker' : 'Linked Transfer from GunBroker'}${data?.sellerUsername ? ` (${data.sellerUsername})` : ''}`}
              color={'black'}
              bg={'white'}
            >
              <Text
                className="link-icon-wrapper-button"
                style={{height:"20px", marginTop:"8px"}}
              >
                <img src="/images/ui/link-icon.svg" />
              </Text>              
            </Tooltip>
           )
        } 
          
        </>
      )}
    </Box>
  );
}
